import { Component, OnInit } from '@angular/core';
import { DialogService } from 'ng2-bootstrap-modal';
import { BcClientListComponent } from '../../bc-client-list/bc-client-list.component';
import { BillingControlService } from '../service/billing-control.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-bc-general',
  templateUrl: './bc-general.component.html',
  styleUrls: ['./bc-general.component.scss']
})
export class BcGeneralComponent implements OnInit {


  private BcGeneralData = [];
  private BcGeneralTotal = 0;

  //Chart Configuration and Data
  hasLegend = 'true'
  chartType = 'pie'
  private chartData = [
    {
      data: []
    }
  ];
  private chartLabels = [];
  private showChart = false;

  constructor(private billingControlService: BillingControlService, private dialogService: DialogService, private router: Router) {
  }

  ngOnInit() {
    this.getBCGeneral();
  }

  getBCGeneral() {
    this.billingControlService.getBCGeneral().subscribe(result => {
      if (result.Success) {
        if (result.Result.length > 0) {
          this.BcGeneralData = result.Result || [];
          this.BcGeneralTotal = result.Total;
          this.defineChartByGeneralData();

          if (this.billingControlService.selectedDirectorship) {
            this.billingControlService.selectedDirectorshipDescription = result.Result[0].Nome;
          }
        } else {
          this.toBillingControl('');
        }
      } else {
        console.log("Erro ao carregar dados de Cobrança Geral");
      }
    }, error => {
      console.log(error);
    });
  }

  defineChartByGeneralData() {
    if (this.BcGeneralData.length > 1) {
      this.BcGeneralData.forEach((row, index) => {
        row.Nome ? this.addChartData(row.Nome, row.Percentual) : this.addChartData('Sem diretoria', row.Percentual);
        if (index == this.BcGeneralData.length - 1) {
          this.showChart = true;
        }
      });
    }
  }

  addChartData(label, data) {
    const tempChartData = this.chartData[0].data;
    tempChartData.push(data);
    this.chartData[0].data = tempChartData;
    this.chartLabels.push(label);
  }

  toBillingControl(id) {
    const dirId = id ? id : '';
    this.router.navigateByUrl('/').then(
      () => {
        this.router.navigateByUrl('/controle-cobranca/' + dirId);
      });
  }

  openModal(tipo, chave, dias) {
    const objToList = {
      Tipo: tipo,
      Chave: chave == '' ? undefined : chave,
      Dias: dias,
      Diretoria: this.billingControlService.selectedDirectorship
    };
    this.dialogService.addDialog(BcClientListComponent, { obj: objToList }, { backdropColor: 'rgba(0, 0, 0, 0.5)' });
  }
}



// WEBPACK FOOTER //
// ./src/app/billing-control/billing-control/bc-general/bc-general.component.ts